module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp2_m_jp.3ba2cad1bba5c2cdf2963a4b2f626e74.png";